  <template>
    <div class="page">
    		<div class="gridheader">
    			<div class="row wrapper">
    				<div class="col-md-2 title"><h1>{{$t('REPORTS')}}</h1></div>
    				<div class="col-md-8 search-form">
    					<form method="get" action="">
                <div class="row">
                  <div class="col-md-3">
        						<div class="form-group">
                      <label>{{$t('STARTDATE')}}</label>
        							<datepicker v-model="params.startDate" :bootstrapStyling="true" format="dd.MM.yyyy" v-bind:placeholder="$t('STARTDATE')"></datepicker>
        						</div>
                  </div>
                  <div class="col-md-3">
        						<div class="form-group">
                      <label>{{$t('ENDDATE')}}</label>
        							<datepicker v-model="params.endDate" :bootstrapStyling="true" format="dd.MM.yyyy" v-bind:placeholder="$t('ENDDATE')"></datepicker>
        						</div>
                  </div>
                  <div class="col-md-2">
        						<div class="form-group">
                      <label>{{$t('STATUS')}}</label>
        							<select v-model="params.status" class="form-control">
                        <option value="closed">{{$t('CLOSED')}}</option>
                        <option value="open">{{$t('OPEN')}}</option>
                      </select>
        						</div>
                  </div>
                  <div class="col-md-2">
        						<div class="form-group">
                      <label>{{$t('COMPANY')}}</label>
        							<autocomplete v-bind:setvalue="setCompanyId" v-bind:value="params.companyId" v-bind:placeholder="$t('COMPANY')" v-bind:values="getCompaniesOptions" v-bind:initdata="getCompanies"></autocomplete>
        						</div>
                  </div>
                  <div class="col-md-2">
        						<div class="form-group">
                      <label>{{$t('RESPONSIBLEPERSON')}}</label>
        							<autocomplete v-bind:setvalue="setUserId" v-bind:value="params.userId" v-bind:placeholder="$t('RESPONSIBLEPERSON')" v-bind:values="getUsersOptions" v-bind:initdata="getUsers"></autocomplete>
        						</div>
                  </div>
                </div>
    					</form>
    				</div>
            <div class="col-md-2"></div>
    			</div>
    		</div>
        <div class="row reports">
          <div class="table-responsive">
      			<table class="maintable reports">
      				<thead>
      					<tr>
      						<td>{{$t('NAME')}}</td>
      						<td>{{$t('SHORTNAME')}}</td>
      					</tr>
      				</thead>
      				<tbody>
      					<tr v-for="protetic in protetics">
      						<td class="">{{protetic.name}}</td>
      						<td class="protetictd">
                    <b-progress :max="max">
                      <b-progress-bar v-bind:style="'background-color: '+protetic.color" height="1.5rem" :value="parseInt(protetic.cnt)">{{protetic.shortname}}</b-progress-bar>
                    </b-progress>
                    <span class="proteticcnt">{{protetic.cnt}}</span>
                  </td>
      					</tr>
      				</tbody>
      			</table>
          </div>
        </div>
    	</div>
  </template>

  <script>

  import { mapActions, mapGetters } from 'vuex'
  import reportsApi from '@/api/reports'
  import companyApi from '@/api/companydata'
  import userApi from '@/api/employees'

  export default {
    name: 'Reports',
    data: function()
    {
      return {
        companies: {
          root: [],
          totalCount: 0
        },
        users: {
          root: [],
          totalCount: 0
        },
        protetics: [],
        params: {
          startDate: new Date(),
          endDate: new Date(),
          status: 'closed',
          companyId: '',
          userId: ''
        }
      };
    },
    created: function()
    {
      var me = this;
      me.getReports(true);
    },
    methods:
    {
      getCompanies: function(params)
      {
        var me = this;
        params.onlyConnected = 1;
        params.includeFictionalCompanies = 1;
        companyApi.selectRow(params, function(data)
        {
          if(data.error)
          {
            me.$notify.error(data.notice);
          }
          else
          {
            me.companies = data;
          }
        });
      },
      getUsers: function(params)
      {
        var me = this;
        userApi.getEmployees(params, function(data)
        {
          if(data.error)
          {
            me.$notify.error(data.notice);
          }
          else
          {
            me.users = data;
          }
        });
      },
      setCompanyId(val)
      {
        var me = this;
        me.params.companyId = val;
      },
      setUserId(val)
      {
        var me = this;
        me.params.userId = val;
      },
      getReports: function(firstLoad)
      {
        var me = this;
        reportsApi.getReports(me.params, function(data)
        {
          if(data.error && data.error == true)
          {
            Vue.$notify.error(data.notice);
            return;
          }

          if(typeof firstLoad != 'undefined' && firstLoad == true)
          {
            var dummyData = Object.assign({}, data.data, {});

            for(var i=0;i<dummyData.length;i++)
            {
              var protetic = dummyData[i];
              protetic.cnt = 0;
            }

            me.protetics = dummyData;

            setTimeout(function()
            {
              me.protetics = data.data;
            }, 500);
          }
          else me.protetics = data.data;

        });
      }
    },
    computed:
    {
      max: function()
      {
        var me = this,
          max = 0;

        for(var i=0;i<me.protetics.length;i++)
        {
          var protetic = me.protetics[i];
          if(max < parseInt(protetic.cnt)) max = parseInt(protetic.cnt);
        }

        return max;
      },
      getCompaniesOptions: function()
      {
        var me = this,
          options = [];

        for(var i=0;i<me.companies.root.length;i++)
        {
          var company = me.companies.root[i];
          options.push({value: company.companyId, text: company.companyName})
        }

        return options;
      },
      getUsersOptions: function()
      {
        var me = this,
          options = [];

        for(var i=0;i<me.users.root.length;i++)
        {
          var user = me.users.root[i];
          options.push({value: user.userId, text: user.name+' '+user.surname})
        }

        return options;
      }
    },
    watch:
    {
      'params.startDate': function()
      {
        var me = this;
        me.getReports(true);
      },
      'params.endDate': function()
      {
        var me = this;
        me.getReports(true);
      },
      'params.status': function()
      {
        var me = this;
        me.getReports(true);
      },
      'params.companyId': function()
      {
        var me = this;
        me.getReports(true);
      },
      'params.userId': function()
      {
        var me = this;
        me.getReports(true);
      }
    }
  }
  </script>



// WEBPACK FOOTER //
// src/components/Reports.vue